import React from 'react'
import { connect } from 'react-redux'
import ReactMarkdown from '../Markdown/Markdown'
import { DumbField, getValidityClass } from './Field'
import { TextInput, DateInput, Checkbox } from './fieldComponents/Form'
import { setWizardSignatureValues } from './WizardActions'
import { getFieldsByType } from 'utilities'
import { resolveFieldConditions } from '@tecuity/wizard-utilities'
import Summary from './fieldComponents/Summary'
import { resolveFieldLogic } from '../../store'

let SignatureSection = ({
  signerAttestations,
  signatureValues,
  setWizardSignatureValues,
  signatureErrors,
  signatureTextLabel,
  signatureDateLabel,
}) => {
  const setAttestationByIndex = (checked, i) => {
    setWizardSignatureValues({
      ...signatureValues,
      attestations: { ...signatureValues.attestations, [i]: checked },
    })
  }

  return (
    <React.Fragment>
      <div className="section">
        <h2>Review & Sign</h2>
        <ReactMarkdown
          className="description"
          source="Review the following information for accuracy and then sign below."
        />
        <Summary />
        <div className="bottom-divider" />
      </div>
      <div className="section">
        <h2>Sign & Submit</h2>
        {signerAttestations.map((att, i) => (
          <DumbField key={i}>
            <Checkbox
              fieldId={`attestation_${i}`}
              label={att}
              value={signatureValues.attestations[i] || false}
              onChange={(checked) => setAttestationByIndex(checked, i)}
            />
          </DumbField>
        ))}
        {signatureErrors.ATTESTATIONS ? (
          <p className="field-error animated fadeIn fast-animation" style={{ marginBottom: 15 }}>
            {signatureErrors.ATTESTATIONS}
          </p>
        ) : null}
        <Signature
          signatureTextLabel={signatureTextLabel}
          signatureDateLabel={signatureDateLabel}
        />
      </div>
    </React.Fragment>
  )
}
SignatureSection = connect(
  (state) => {
    const filingMethod =
      state.wizard.requirePrintMailMethod.size > 0
        ? [{ value: { method: 'mail' } }]
        : getFieldsByType('UploadAndSubmit', state.wizard.wizard.fields)
    const activeFilingMethods =
      filingMethod &&
      filingMethod.filter(
        (field) =>
          resolveFieldConditions(
            field.conditions,
            state.wizard.wizard.fields,
            field.conditionsOperator
          ) && (field.logicNodes ? resolveFieldLogic(field).active : true)
      )
    const method = activeFilingMethods[0]
    return {
      signatureValues: state.wizard.signatureValues,
      signerAttestations: method ? method.signerAttestations : [],
      signatureErrors: state.wizard.signatureErrors,
      signatureTextLabel: method ? method.signatureTextLabel : '',
      signatureDateLabel: method ? method.signatureDateLabel : '',
    }
  },
  { setWizardSignatureValues }
)(SignatureSection)
export default SignatureSection

let Signature = ({
  signatureValues,
  signatureErrors,
  setWizardSignatureValues,
  signatureTextLabel,
  signatureDateLabel,
}) => {
  const THIRD_PARTY_SIGNATURE_DEFAULT_DATE = process.env.THIRD_PARTY_SIGNATURE_DEFAULT_DATE

  return (
    <div className="panel signatures">
      <div className="row">
        <div className="col-sm-7">
          <DumbField
            label={signatureTextLabel || 'Full name'}
            errorMessage={[signatureErrors.SIGNATURE]}
          >
            <TextInput
              value={signatureValues.SIGNATURE}
              onChange={(value) =>
                setWizardSignatureValues({ ...signatureValues, SIGNATURE: value })
              }
              width="100%"
              validityClass={getValidityClass(!signatureErrors.SIGNATURE ? null : false)}
            />
          </DumbField>
        </div>
        <div className="col-sm-5">
          <DumbField
            label={signatureDateLabel || 'Date of signing'}
            errorMessage={[signatureErrors.SIGNED_DATE]}
          >
            <DateInput
              value={signatureValues.SIGNED_DATE}
              onChange={(value) =>
                setWizardSignatureValues({ ...signatureValues, SIGNED_DATE: value })
              }
              width="100%"
              todayButton={THIRD_PARTY_SIGNATURE_DEFAULT_DATE ? false : true}
              disabled={THIRD_PARTY_SIGNATURE_DEFAULT_DATE}
              validityClass={getValidityClass(!signatureErrors.SIGNED_DATE ? null : false)}
            />
          </DumbField>
        </div>
      </div>
    </div>
  )
}
Signature = connect(
  (state) => ({
    signature: state.wizard.signature,
    signatureValues: state.wizard.signatureValues,
    signatureErrors: state.wizard.signatureErrors,
  }),
  { setWizardSignatureValues }
)(Signature)
